import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props) {
  let appointment_id = useDataValue({
    context: 'patient',
    path: 'booking.appointment._id',
    viewPath: props.viewPath,
  })

  return {
    variables: {
      appointment_id,
    },
    pause: !appointment_id,
  }
}
